import React, {Fragment, useEffect,  useState} from 'react';
import PropTypes from "prop-types";

import {useForm} from "react-hook-form";
import ModalContentWrapper from '../ModalContentWrapper';
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import {getResourceDetails, createResource, updateResource, deleteResource } from "root/DataFunctions/ResourceDataFns";
import DemoModal from "root/DemoModal";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import DropdownResourceTypes from "root/ReactHookForm/ui/DropdownResourceTypes";
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import SingleFilePicker from "root/ReactHookForm/ControlWrappers/SingleFilePicker";
import {IconPath} from "root/DataFunctions/Constants";
import VanillaModal from "../VanillaModal/VanillaModal";

const ModalAddResource = (props) =>
{
    const [buttonState, setButtonState] = useState ('') ;
    const [data, setData] = useState({ isLoading: props.resource_id !== null, data: [] });
    const [newImageData, setNewImageData] = useState( null );
    const [imageDataAlias, setImageDataAlias] = useState( null );

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                resource: {
                    resource_id: { value : 0 } , /* This field uses raw dropdown-select objects */
                    name: '',
                    description: '',
                    link: '',
                    type_id: undefined,
                    document: ''
                }
            }
        });

    const titles = {
        view: 'View Resource',
        edit: 'Edit Resource',
        create: 'New Resource',
        delete: 'Delete Resource'
    } ;

    const submitButtonText = () => {
        switch (props.mode){
            case 'view':
                return 'Close';
                break;
            case 'edit':
                return 'Save';
                break;
            case 'create':
                return 'Save';
                break;
            case 'delete':
                return 'Delete';
                break;
        }
    } ;

    useEffect(() =>
    {
        if ( props.resource_id !== null )
        {
            getResourceDetails(props.resource_id, (response) =>
            {
                let resourceData = getDataFromResponse(response)[0] ;
                setValue ( 'resource',
                    {
                        resource_id: { value: resourceData.resource_id},
                        name: resourceData.name,
                        description: resourceData.description,
                        type_id: { value: +(resourceData.type_id),
                        link:resourceData.link},
                        document: resourceData.document_id,
                    }) ;

                setData({ isLoading: false, data: resourceData });
                setImageDataAlias(resourceData.icon_id);
            });
        }
        else
        {
            if ( props.mode === 'create')
            {
                setData({ isLoading: false});
            }
        }

    }, [props.resource_id]);

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const alertShow = ( title, message, action ) =>
    {
        let cfrm = new VanillaModal ({
            title: title,
            content: message,
            buttons: VanillaModal.buttons.alert
        })

        cfrm.show().once('dismiss', (modal, ev, button) => {
            action() ;
        });
    }

    const confirmShow = (title, message, action) =>
    {
        let cfrm = new VanillaModal ({
            title: title,
            content: message,
            buttons: VanillaModal.buttons.confirm
        })

        cfrm.show().once('dismiss', (modal, ev, button) => {
            if (button && button.value === true)
            {
                action() ;
            }
        });
    }

    const doCreate = ( formData ) =>
    {
        createResource(formData).then((response) =>
        {
            alertShow('Resource', 'New Resource Created', () =>
            {
                props.onSaveCompleted ('saved');
                props.onClose() ;
            })

        });
    }

    const doUpdate = ( formData ) =>
    {
        updateResource(props.resource_id, formData, (response) =>
        {
            alertShow('Resource', 'New Resource Updated', (result =>
                {
                    props.onSaveCompleted ('saved');
                    props.onClose() ;
                }
            ))
        });
    }

    const doDelete = ( callback ) =>
    {
        deleteResource (props.resource_id, (response) =>
        {
            props.onSaveCompleted ('saved');
            props.onClose() ;
        });
    }

    const Title = ( props ) =>
    {
        return <h3>{titles[props.mode]}</h3>
    }

    const isViewOnly = props.mode === 'view';

    const getSubmitButtonText = ( mode ) =>
    {
        return submitButtonText() ;
    }

    const getSubmitButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const submitButton = (mode, onClick) =>
    {
        const clickHandler = buttonState === '' ? onClick : null;

        return (
            <button onClick={clickHandler} type='button' style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSubmitButtonStyle(mode)}>{getSubmitButtonText(mode)}<i className="et-save" /></button>
        )
    }

    const onSubmit = (data, status) => {

        switch (props.mode)
        {
            case 'create' :
                data.resource['image'] = newImageData;
                doCreate(data.resource);
                break;

            case 'edit' :
                if (newImageData !== null) data.resource['image'] = newImageData;
                doUpdate(data);
                break;

            case 'delete' :
                confirmShow('Delete Resource', 'Are you sure you wish to delete this resource?', (result =>
                    {
                        doDelete(); //action only happens if they confirm
                    }))
                break;
        }
    }

    const onClickSaveButton = (status) => {
        handleSubmit(onSubmit)(status);
    }

    const onImageChange = ( imageUrl ) =>
    {
        const reader = new window.FileReader();
        reader.readAsDataURL(imageUrl);

        reader.onloadend = () =>
        {
            setNewImageData ( reader.result ) ;
            setImageDataAlias ( reader.result ) ;
        }
    }

    const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;

    const handleRemoveImage = () => {
        setNewImageData("");
        setImageDataAlias(null);
    }

    const handleUnsetDocument = () => {
        setValue('resource.document', "");
        const dataHolder = { ...data.data, document_id: null };
        setData({ ...data, data: dataHolder });
    }

    const getDocumentIcon = (  ) =>
    {
        let icon = IconPath.ICON_DOCUMENT;
        return icon;
    }

    const renderHookForm = ( prop )  =>
    {
        const readOnlyMode = props.mode === 'view' || props.mode === 'delete' ? 'readonly' : '' ;
        const image_id = props.mode === 'create' ? null : data.data.icon_id

        return (
            <Fragment>
                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                    <label>Icon</label>
                    <div className="profile-img-container-wrap profile-img-container-wrap_child">

                        {!isReadOnly &&  
                        <div className="post-all-image-wrap">
                            <div
                                className={imageDataAlias === null ?
                                            "post-all-image"
                                            :
                                            "post-all-image post-all-image_show"
                                        }
                            >
                                <DemoModal 
                                image_id={image_id}
                                provider_id={1} 
                                dimensions={150} 
                                onImageChange={onImageChange}
                                newImageData={newImageData}
                                imageDataAlias={imageDataAlias}
                                data={data}
                                />
                                <span onClick={handleRemoveImage} className="post-image-remove">
                                    <i className='icon-close'/>
                                </span>
                                <div className="post-all-image-overlay post-all-image-overlay_single"></div>
                            </div>
                        </div>
                        }
                        {isReadOnly && <img src={getDocumentUrl(data.data.icon_id)} style={{width: '150px'}} />}
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Title</label>
                                <input readOnly={readOnlyMode} className='form-control' name='resource.name' id='name' {...register("resource.name")} />
                                { formErrors.resource?.name && <ErrorDiv>Please enter a title</ErrorDiv> }
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Description</label>
                                <textarea readOnly={readOnlyMode} style={{minHeight: '10em'}} name='resource.description' className='form-control' id='description' {...register("resource.description")} />
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Resource Type</label>
                                <DropdownResourceTypes readOnly={isReadOnly} control={control}
                                                   mode={props.mode} name='resource.type_id'
                                                   rules={{required: false}}
                                                   placeholder='Please select a resource type'
                                                   isSearchable={true}
                                                   isClearable={true}/>
                                {formErrors.resource?.type_id &&
                                    <ErrorDiv>{formErrors.resource.type_id.message}</ErrorDiv>}
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Link</label>
                                <input readOnly={readOnlyMode} className='form-control' name='resource.link' id='link' {...register("resource.link")} />
                                { formErrors.resource?.link && <ErrorDiv>Please enter a link</ErrorDiv> }
                            </div>
                        </div>
                    </div>

                    <div>
                        {(props.mode !== 'create' && data.data.document_id !== null) &&
                            <div>
                                <label>Document (PDF)</label>
                                <div style={{position: 'relative', marginRight: '10px', marginBottom: '20px', marginTop: '20px'}}>
                                    <a href={'/getFile.php?enc_docid='+ data.data.document_id} target="_blank" ><img alt="document" width="70" src={getDocumentIcon()}/></a>
                                    {!isReadOnly && <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="tooltip-right">
                                                Remove Document
                                            </Tooltip>
                                        }
                                    >
                                        <span onClick={() => handleUnsetDocument()} style={{position: 'absolute', top: '-15px', fontSize: '2.3rem', color: 'red', lineHeight: '8px', cursor: 'pointer'}}>
                                            x
                                        </span>
                                    </OverlayTrigger>}
                                </div>
                            </div>
                        }

                        {!isReadOnly &&
                            <div>
                                <label>Add a Document (PDF)</label>
                                <SingleFilePicker
                                    name='resource.document'
                                    control={control }
                                    options={{ maxSizeMb: 20, accept: ['.doc', '.pdf', '.docx']}}
                                    unsetDocument={handleUnsetDocument}
                                />
                            </div>
                        }
                    </div>

                    <div className="d-flex flex-row justify-content-end" style={{marginTop: '15px'}}>
                        {!isViewOnly && <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i className="et-arrow-bold-left" /></button>}
                        {!isViewOnly && submitButton(props.mode, onClickSaveButton)}
                    </div>
                </form>
            </Fragment>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} />
            <div style={{width: props.width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && renderHookForm ()}
            </div>
        </ModalContentWrapper>
    )
}

export default ModalAddResource;

ModalAddResource.defaultProps =
{
    width: '600px'
}

ModalAddResource.propTypes = {
    resource_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
